export type InboxSource = "gmail" | "outlook" | "noxus";

export type InboxUseCase =
  | "customer_enquiries"
  | "email_triage"
  | "document_extraction";

export interface InboxSourceConfig {
  id: InboxSource;
  name: string;
  description: string;
  icon: string;
  integration?: string;
  conversational: boolean;
  comingSoon?: boolean;
  category: "external" | "noxus";
  hasConfiguration?: boolean;
}

export interface InboxUseCaseConfig {
  id: InboxUseCase;
  name: string;
  description: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  comingSoon?: boolean;
}

export interface WizardState {
  source: InboxSource | null;
  sourceConfig: Record<string, any>;
  useCase: InboxUseCase | null;
  context: Record<string, any>;
}

export type WizardStep =
  | "intro"
  | "hiw_1"
  | "hiw_2"
  | "hiw_3"
  | "source"
  | "source_config"
  | "use_case"
  | "context"
  // | "review"
  | "done";

export const WIZARD_STEPS: WizardStep[] = [
  "intro",
  "hiw_1",
  "hiw_2",
  "hiw_3",
  "source",
  "source_config",
  "use_case",
  "context",
  // "review",
  "done",
];

export const STEP_LABELS: Record<WizardStep, string> = {
  intro: "Intro",
  hiw_1: "How it works (1/3)",
  hiw_2: "How it works (2/3)",
  hiw_3: "How it works (3/3)",
  source: "Source",
  source_config: "Configure source",
  use_case: "Use case",
  context: "Details",
  // review: "Review",
  done: "Done",
};
